export default class BenefitRedeemedUIModel {
  constructor({
    cobrandCode = undefined,
    description = undefined,
    legCode = undefined,
  }) {
    this.cobrandCode = cobrandCode;
    this.description = description;
    this.legCode = legCode;
  }

  toAPI() {
    return {
      '_meta': {
        'class': 'BenefitRedeemed',
      },
      cobrandCode: this.cobrandCode,
      description: this.description,
      legCode: this.legCode,
    };
  }
}
